import React, { useState, useEffect } from 'react';

import { FormattedMessage } from 'react-intl';
import CollapsibleContainer, { Trigger } from './CollapsibleContainer';
import HpaContactFormContainer from './hpaContact/HpaContactFormContainer';
import OTButtonGroup from '../../../components/tag/OTButtonGroup';
import OTButton from '../../../components/tag/OTButton';
import ConfirmationModal from '../../../components/tag/ConfirmationModal';
import { isEmpty } from 'lodash';
import {
  doRemoveHpaContact,
  doUpdateHpaContact,
  resetError,
} from '../data/actions';
import { connect } from 'react-redux';
import { USERINFO } from '../../../data/reducer';
import Alert from '../../../components/Alert';
import Loader from '../../../components/Loader';
import OTIcon from '../../../components/tag/OTIcon';

let { id: module_id } = module;

const HpaContacts = (props) => {
  const { hpaContact, actions, isHpaSession } = props;

  const [collapsibleState, toggleCollapsible] = useState(true);
  const [collapsibleContentState, toggleCollapsibleContent] = useState('INFO');
  const [hpaContactInfo, setHpaContactInfo] = useState({
    notificationAgreement: null,
    phone: '',
    email: '',
  });
  const [errors, setErrors] = useState('');
  const [disableButtonState, setDisableButtonState] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [lastEdited, setLastEdited] = useState('');
  const [confirmFieldValues, setConfirmFieldValues] = useState({
    confirmEmail: '',
    confirmPhone: '',
  });

  useEffect(() => {
    toggleDisableButton();
  }, [hpaContactInfo, errors]);

  useEffect(() => {
    if (hpaContact.data.notificationAgreement !== null) {
      setHpaContactInfo({
        ...hpaContact.data,
        notificationAgreement: !hpaContact.data.notificationAgreement
          ? 'deny'
          : 'agree',
      });
    } else {
      setHpaContactInfo({
        ...hpaContact.data,
      });
    }
  }, [hpaContact.data]);

  const initializeValues = () => {
    setErrors('');
    setHpaContactInfo({
      ...hpaContact.data,
      notificationAgreement: !hpaContact.data.notificationAgreement
        ? 'deny'
        : 'agree',
    });
    setConfirmFieldValues({ confirmEmail: '', confirmPhone: '' });
    setDisableButtonState(true);
    toggleCollapsibleContent('INFO');
  };

  //State for input values in PhoneAndEmailInformation.js
  const handleChange = (event) => {
    setHpaContactInfo({
      ...hpaContactInfo,
      [event.target.name]: event.target.value,
    });
    setLastEdited(event.target.name);
  };

  //State for confirm input values in PhoneAndEmailInformation.js
  const handleConfirmField = (event) => {
    setConfirmFieldValues({
      ...confirmFieldValues,
      [event.target.name]: event.target.value,
    });
  };

  const updateHpaContact = () => {
    if ((isEmpty(errors) && hpaContactInfo.phone) || hpaContactInfo.email) {
      const hpaOver18Contact = changeNotificationAgreementFormat();
      actions.updateHpaContact(hpaOver18Contact).then(() => {
        initializeValues();
      });
    }
  };

  //Change notificationAgreement to boolean value
  const changeNotificationAgreementFormat = () => {
    return {
      ...hpaContactInfo,
      notificationAgreement: hpaContactInfo.notificationAgreement === 'agree',
    };
  };

  const handleCancel = () => {
    initializeValues();
  };

  const removeHpaContact = () => {
    actions.removeHpaContact().then(() => initializeValues());
  };

  const toggleDisableButton = () => {
    // if values haven't changed,
    // if there is errors,
    // disable save button

    const checkStates =
      Object.keys(errors).length !== 0 ||
      hpaContactInfo.notificationAgreement === null;

    setDisableButtonState(checkStates);
  };

  let stateButtons = '';

  if (collapsibleContentState === 'INFO' && isHpaSession) {
    stateButtons = (
      <OTButton
        onClick={() =>
          toggleCollapsibleContent(
            hpaContact.data.phone === '' || hpaContact.data.phone === '-'
              ? 'ADD'
              : 'EDIT'
          )
        }
        className={'ot-button--edit'}
      >
        <FormattedMessage
          id={`${
            hpaContact.data.phone === '' || hpaContact.data.phone === '-'
              ? 'hpa.add.contact'
              : 'edit'
          }.information`}
        >
          {(txt) => <>{txt}</>}
        </FormattedMessage>
      </OTButton>
    );
  } else if (collapsibleContentState === 'INFO' && !isHpaSession) {
    stateButtons = (
      <OTButton
        onClick={() => setShowModal(true)}
        disabled={hpaContact.data.phone === '' || hpaContact.data.phone === '-'}
        className={'ot-button--delete'}
      >
        <OTIcon config={{ type: 'fa', name: 'fa-times' }} />
        <FormattedMessage id={'hpa.remove.contact'}>
          {(txt) => txt}
        </FormattedMessage>
      </OTButton>
    );
  } else {
    stateButtons = (
      <>
        <OTButton
          onClick={() => handleCancel()}
          className={'ot-button--cancel'}
        >
          <FormattedMessage id={'cancel'}>
            {(txt) => <>{txt}</>}
          </FormattedMessage>
        </OTButton>

        <OTButton
          onClick={() => updateHpaContact()}
          disabled={disableButtonState}
          className={'ot-button--save'}
        >
          <FormattedMessage id={'save'}>{(txt) => txt}</FormattedMessage>
        </OTButton>

        {
          //Uranus doesn't support removing of values

          collapsibleContentState !== 'ADD' && (
            <OTButton
              onClick={() => setShowModal(true)}
              className={'ot-button--delete'}
            >
              <OTIcon config={{ type: 'fa', name: 'fa-times' }} />
              <FormattedMessage id={'hpa.remove.contact'}>
                {(txt) => txt}
              </FormattedMessage>
            </OTButton>
          )
        }
      </>
    );
  }

  return (
    <>
      <CollapsibleContainer
        className={'ot-collapsible-hpa-contacts'}
        collapsibleClassNames={'ot-collapsible'}
        showContent={collapsibleState}
        toggleShowContent={() => toggleCollapsible(!collapsibleState)}
        content={
          !hpaContact.error ? (
            <>
              <div className={'ot-collapsible-content'}>
                <HpaContactFormContainer
                  errors={errors}
                  setErrors={setErrors}
                  hpaContactInfo={hpaContactInfo}
                  handleChange={handleChange}
                  lastEdited={lastEdited}
                  confirmFieldValues={confirmFieldValues}
                  handleConfirmField={handleConfirmField}
                  collapsibleContentState={collapsibleContentState}
                  savedContactInfo={hpaContact.data}
                />
              </div>
              {hpaContact.isFetching ? (
                <Loader />
              ) : (
                <OTButtonGroup fullWidth expectedCount={1}>
                  {stateButtons}
                </OTButtonGroup>
              )}
            </>
          ) : (
            <Alert message={`default.error.message`} />
          )
        }
        trigger={
          <Trigger
            icon={'icon-user'}
            name={<FormattedMessage id={'hpa.contacts.title'} />}
          />
        }
        controls={<></>}
      />
      {!!showModal && (
        <ConfirmationModal
          confirmationFunction={removeHpaContact}
          isOpen={showModal}
          hideModal={() => setShowModal(false)}
          moduleId={module_id}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    hpaContact: state[USERINFO],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      updateHpaContact: (formData) => dispatch(doUpdateHpaContact(formData)),
      removeHpaContact: () => dispatch(doRemoveHpaContact()),
      resetError: () => dispatch(resetError()),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HpaContacts);
